/**
 * Created by superman on 17/2/16.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
	mainMenu: [],
    token: '',
    routeList: [],
    historyPages:[],
    loginUser: {},
    menuCd: '',
    rememberUser: {},
    dictData: {},
    originList: [],
    orgList: [],
    roleList: [],
    applyUsrList: [],
    settleUsrList: [],
    showAlerFg: ''
  },
  mutations: {
    saveMainMenu: (state, data) => {
      state.mainMenu = data
    },
    saveToken: (state, token) => {
      state.token = token
    },
    saveRouteList: (state, data) => {
      state.routeList = data
    },
    saveHistoryPages: (state,value) => {
      state.historyPages = value
    },
    saveLoginUser: (state, value) => {
      state.loginUser = value
    },
    saveMenuCd: (state, value) => {
      state.menuCd = value
    },
    saveRememberUser: (state, value) => {
      state.rememberUser = value
    },
    saveDictData: (state, value) => {
      state.dictData = value
    },
    saveOriginList: (state, value) => {
      state.originList = value
    },
    saveOrgList: (state, value) => {
      state.orgList = value
    },
    saveRoleList: (state, value) => {
      state.roleList = value
    },
    saveApplyUsrList: (state, value) => {
      state.applyUsrList = value
    },
    saveSettleUsrList: (state, value) => {
      state.settleUsrList = value
    },
    saveShowAlerFg: (state, value) => {
      state.showAlerFg = value
    },
    remove(state) {
      state = {
    	mainMenu: [],
        token: '',
        routeList: [],
        historyPages:[],
        loginUser: {},
        menuCd: '',
        rememberUser: {},
        dictData: {},
        originList: [],
        orgList: [],
        roleList: [],
        applyUsrList: [],
        settleUsrList: [],
        showAlerFg: ''
      }
    }
  },
  getters: {
	mainMenu: (state) => () => {
	  return state.mainMenu
	},
    token: (state) => () => {
      return state.token
    },
    routeList: (state) => () => {
      return state.routeList
    },
    historyPages: (state) => () => {
      return state.historyPages;
    },
    loginUser: (state) => () => {
      return state.loginUser
    },
    menuCd: (state) => () => {
      return state.menuCd
    },
    rememberUser: (state) => () => {
      return state.rememberUser
    },
    dictData: (state) => () => {
      return state.dictData
    },
    originList: (state) => () => {
      return state.originList
    },
    orgList: (state) => () => {
      return state.orgList
    },
    roleList: (state) => () => {
      return state.roleList
    },
    applyUsrList: (state) => () => {
      return state.applyUsrList
    },
    settleUsrList: (state) => () => {
      return state.settleUsrList
    },
    showAlerFg: (state) => () => {
      return state.showAlerFg
    }
  },
  actions: {
    logout(context) {
	  context.commit('remove')
    },
    refreshMainMenu({commit, state}) {
      Vue.axios.get('selectMenuList').then(({data}) => {
        commit('saveMainMenu', data.retResult)
      })
    },
    refreshDictData({commit, state}) {
      Vue.axios.get('/combox/getDictData').then(({data}) => {
        commit('saveDictData', data.retResult)
      })
    },
    refreshOriginList({commit, state}) {
      Vue.axios.get('/origin/selectOriginList').then(({data}) => {
        commit('saveOriginList', data.retResult)
      })
    },
    refreshOrgList({commit, state}) {
      Vue.axios.get('/organization/selectAllOrgs').then(({data}) => {
        commit('saveOrgList', data.retResult)
      })
    },
    refreshRoleList({commit, state}) {
      Vue.axios.get('/role/selectRoleOptions').then(({data}) => {
        commit('saveRoleList', data.retResult)
      })
    },
    refreshApplyUsrList({commit, state}) {
      Vue.axios.get('/usr/selectApplyUsrList').then(({data}) => {
        commit('saveApplyUsrList', data.retResult)
      })
    },
    refreshSettleUsrList({commit, state}) {
      Vue.axios.get('/usr/selectSettleUsrList').then(({data}) => {
        commit('saveSettleUsrList', data.retResult)
      })
    },
    refreshSearchUsrList({commit, state}) {
      Vue.axios.get('/usr/syncLoginSearchUsr').then(({data}) => {})
    }
  },
  plugins: [createPersistedState({
    key: 'sws_state',
    storage: window.sessionStorage
  })]
})
